import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import NotFound404Exception from "@/exceptions/NotFound404Exception";
export var api__getPostInspection = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(postId) {
    var _res$data, _res$data$data, _res$data2, _res$data2$data, _res$data2$data$inspe, _res$data3, _res$data3$data;
    var params, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = {
            id: postId,
            thumb_size: 300,
            device_type: "web",
            include: "inspection"
          };
          _context.next = 3;
          return fetcher().get("/post/view-online", {
            params: params
          });
        case 3:
          res = _context.sent;
          if (!(!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.inspection) || (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : (_res$data2$data$inspe = _res$data2$data.inspection) === null || _res$data2$data$inspe === void 0 ? void 0 : _res$data2$data$inspe.length) === 0)) {
            _context.next = 6;
            break;
          }
          throw new NotFound404Exception("Report for post ".concat(postId, " Not Found"));
        case 6:
          return _context.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : _res$data3$data.inspection) || null);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__getPostInspection(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getPostInspectionData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(req, id) {
    var _res$data4;
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetcher(req).get("/post/view-details?id=".concat(id, "&is_online=1&thumb_size=300&device_type=web&include=inspection,details,g4_data"));
        case 2:
          res = _context2.sent;
          if (!((res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.code) === 200)) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", res.data.data);
        case 7:
          throw new NotFound404Exception("Report for post ".concat(id, " Not Found"));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__getPostInspectionData(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();